import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Certificate Management</Typography>

      <p>This page is shown only when your Apple Wallet passes use a certificate from your own Apple developer team. Smartix-managed certificates renew automatically and do not need action here.</p>

      <p>When renewal is due, download the CSR, submit it when creating a replacement Pass Type ID certificate in your Apple Developer account, then upload the resulting PEM certificate here. The replacement must use the displayed Pass Type ID and Team ID.</p>

      <p>Smartix emails your main contact monthly once the certificate has less than five months remaining. Please renew promptly so existing passes continue to update correctly.</p>

    </div>
  )
}

export default HelpText
